export const isReceiptsModuleEnabled = (organization?: any): boolean => {
  const value = organization?.enableReceiptsModule;
  return value === true || value === "true";
};
